#import './email-sequence-template-stub-basic.graphql'

fragment EmailSequenceTemplateStubFragment on EmailSequenceTemplate {
    ...EmailSequenceTemplateStubBasic
    emailSequenceTemplateMessages {
        id
        emailTemplate {
            id
        }
    }
}
